                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      import React from 'react';
import {Button} from 'react-bootstrap'
import SettingsTextInput from '../../../components/UserProfil/Settings/SettingsTextInput';
import SettingsInterface from '../../../components/UserProfil/Settings/SettingsInterface';

/*
    this class regroup the text input for the email and the name of the user
    text Input are ine file SettingsTextInput 
*/

interface AccountParametersSettingsProps
{
	state: SettingsInterface
    handleChange(event: React.FormEvent<HTMLInputElement>, target: string): void
    submitNewInformation(): void
}

interface AccountParametersState {
}

export default class AccountParametersSettings extends React.Component<AccountParametersSettingsProps, AccountParametersState> {
	
	constructor(props: AccountParametersSettingsProps) {
        super(props);
        this.state = {
		};
    }

    render() {
        return (
            <div id="account_profile_param">
                <div id="email" className={"row"}>
                    <SettingsTextInput
						name="email"
                        label={"Adresse e-mail"}
                        value={this.props.state.email}
                        error={this.props.state.errorEmail}
                        placeholder= "Ex: test.test@orange.fr"
                        handleChange={(e) => this.props.handleChange(e, "email")}
                    />
                </div>
                <br/>
                <div id="lastName" className={"row"}>
                    <SettingsTextInput
                        name="lastName"
                        label={"Nom"}
                        value={this.props.state.name}
                        error={this.props.state.errorName}
                        placeholder= "Ex: Toto1"
                        handleChange={(e) => this.props.handleChange(e, "name")}
                    />
                </div>
                <br/>
                <br/>
                <Button variant="success" onClick={this.props.submitNewInformation}>Modifier</Button>
            </div>
        );
    }
}